import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TebGiderService } from '../ctl-teb-gider.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: TebGiderService) {}

    getData(control: any) {
      let baseEntity= control.dlistMetadata.baseEntity
      if(this.service.tasinirKod)  baseEntity=baseEntity+'?ExTasinirKod='+this.service.tasinirKod
      const dataSource = this.dataCoreService.getOData(baseEntity);
            dataSource.select([
                'Kod',
                'Ad',
                'Donem',
                'EkoGiderKod',
            ]);


            const filterArr = [];
            if(this.service.period) filterArr.push(['Donem', '=', this.service.period]);
            filterArr.push(['EkoGiderKod.Length', '>=', 6]);
            dataSource.filter(filterArr)
            return dataSource;
    }

}
